import APIClient from "../../../common/APIClient";
import {
  displayError,
  MAX_ITEMS_IN_PAGE,
  SUCCESS_ALERT,
  toggleShowAlert,
  togglePrompt,
} from "../commonActions";
import qs from "qs";

const FETCH_USERS = "FETCH_USERS";
const USER_FILTER = "USER_FILTER";
const SET_USER = "SET_USER";
const RESET_USER = "RESET_USER";
const SET_USER_FIELD_CHANGE = "SET_USER_FIELD_CHANGE";
const CLEAR_USERS = "CLEAR_USERS";

export const DISABLED_USER = 1;
export const ACTIVE_USER = 0;
export const ENABLE_USER_ACTION = "ENABLE_USER_ACTION";
export const DISABLE_USER_ACTION = "DISABLE_USER_ACTION";
export const SET_USERS_PAGINATION = "SET_USERS_PAGINATION";
export const RESET_USERS_PAGINATION = "RESET_USERS_PAGINATION";
export const USER = 1;
export const COMPANY_ADMIN = 2;
export const SUPER_ADMIN = 3;

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
};

export const fetchUsers = (
  filters = null,
  page = 1,
  limit = MAX_ITEMS_IN_PAGE
) => {
  if (!filters) {
    filters = {};
  }

  return (dispatch, getState) => {
    page = getState().users.currentPage;

    client()
      .get("admin/list", {
        params: {
          filters,
          page,
          limit,
        },
        paramsSerializer: (params) => {
          return qs.stringify(params);
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          let users = result.data;
          let pagination = result.pagination;

          if (!users.length) {
            users = null;
          }

          let max =
            pagination?.total_items < MAX_ITEMS_IN_PAGE
              ? pagination?.total_items
              : getState().users.max;

          dispatch({
            type: FETCH_USERS,
            users,
            currentPage: getState().users.currentPage,
            totalItems: pagination?.total_items,
            totalPages: pagination?.total_pages,
            max,
          });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const filterUsers = (filter) => {
  return (dispatch) => {
    dispatch({ type: USER_FILTER, filter });
  };
};

export const getUser = (id) => {
  return (dispatch) => {
    client()
      .get("admin/get-by-id", {
        params: {
          id,
        },
      })
      .then((json) => {
        const result = json.data;

        if (result) {
          const user = result.data;

          if (user?.roles) {
            user.role_id = user?.roles[0]?.id;
          }

          if (user?.company) {
            user.company_id = user?.company?.id;
          }

          dispatch({ type: SET_USER, user });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const resetUser = () => {
  return (dispatch) => {
    dispatch({ type: RESET_USER });
  };
};

export const upsertAdminUserInfo = (successCallback = null) => {
  return (dispatch, getState) => {
    const user = getState().users.user;
    user.roles = [user.role_id];

    let endpoint = "admin/create";
    let message = "Admin User info has been successfully created";

    if (user.id) {
      endpoint = "admin/update";
      message = "Admin User info has been successfully created";
    }

    client()
      .post(endpoint, user)
      .then((json) => {
        const result = json.data;
        if (result) {
          dispatch(toggleShowAlert(true, SUCCESS_ALERT, message));
          if (successCallback) {
            successCallback();
          }
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const handleInputChange = (e, definedValue = null) => {
  return (dispatch) => {
    let value = {};
    if (!e && definedValue) {
      value = definedValue;
    } else {
      const id = e.target.id;

      value = {
        [id]: e.target.value,
      };
    }

    dispatch({ type: SET_USER_FIELD_CHANGE, value });
  };
};

export const toggleUser = (action, user, successCallback = null) => {
  return (dispatch) => {
    let endpoint = "";
    let message = "";

    if (action === ENABLE_USER_ACTION) {
      endpoint = "/admin/enable";
      message = "Admin has been successfully enabled.";
    } else {
      endpoint = "/admin/disable";
      message = "Admin has been successfully disabled.";
    }

    client()
      .get(endpoint, {
        params: {
          id: user?.id,
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          dispatch(toggleShowAlert(true, SUCCESS_ALERT, message));
          if (successCallback) {
            successCallback();
          }
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
        dispatch(togglePrompt(false));
      });
  };
};

export const clearUsers = () => {
  return (dispatch) => {
    dispatch({ type: CLEAR_USERS });
  };
};

export const searchUsers = (searchKeyword, searchCallback = null) => {
  return (dispatch) => {
    dispatch(clearUsers());

    searchCallback({
      search: searchKeyword,
    });
  };
};
